import { __awaiter, __decorate, __extends, __generator, __spreadArrays } from "tslib";
import { Options } from 'vue-class-component';
import AvalonGTView from '@/utils/libs/BaseView';
import { PageService } from '@/views/copy/invite/import';
import { AvalonGTEvent } from '@/utils/Event';
import Qrcode from '@/views/copy/invite/page/Qrcode.vue';
import QrcodeApp from '@/views/copy/invite/page/QrcodeApp.vue';
import AvalonGTGlobal from '@/utils/factory/Global';
import { Toast } from 'vant';
import commonConfig from '@/common/CommonConfig';
import UnbindDialog from '@/views/copy/invite/page/components/UnbindDialog.vue';
import moment from 'moment';
import CommonService from '@/service/Common';
import myDialog from '@/components/assist/dialog.vue';
import NavSelect from '@/components/assist/navSelect.vue';
import inviteImgs from './imgs';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inviteImgs = inviteImgs;
        _this.componentId = null;
        _this.tabList = [
            {
                title: '我的邀请',
                index: 2,
            },
            {
                title: '邀请奖励',
                index: 1,
            },
        ];
        _this.tabActive = {
            tabIndex: 2,
            component: 'InvitePanel',
        };
        _this.inviteList = [];
        _this.inviteInfo = {};
        _this.type = 1;
        _this.pageIndex = 1;
        _this.navH = 0;
        _this.statusH = 0;
        _this.bannerList = [];
        _this.h5Config = {};
        _this.package = '';
        _this.showDialog = false;
        /** 弹窗打开时锁定的滚动位置，关闭后还原，避免滚动穿透与位置跳动 */
        _this.dialogScrollTop = 0;
        _this.searchVal = '';
        _this.loading = false;
        _this.finished = false;
        _this.isLoad = false;
        _this.selectActive = 0;
        _this.selectList = [
            { text: '今日奖励', value: 0 },
            { text: '昨日奖励', value: 3 },
            { text: '本周奖励', value: 1 },
            { text: '上周奖励', value: 2 },
        ];
        _this.calendarShow = false;
        return _this;
    }
    Object.defineProperty(View.prototype, "showSupplement", {
        get: function () {
            return this.inviteInfo.userType == '3' || this.inviteInfo.userType == '1';
        },
        enumerable: false,
        configurable: true
    });
    View.prototype.formatInviteDate = function (t) {
        if (!t)
            return '--';
        var m = moment(t);
        return m.isValid() ? m.format('YYYY-MM-DD') : String(t).split(' ')[0] || '--';
    };
    View.prototype.formatInviteTime = function (t) {
        if (!t)
            return '';
        var m = moment(t);
        return m.isValid() ? m.format('HH:mm') : (String(t).split(' ')[1] || '').slice(0, 5);
    };
    View.prototype.hasInviteStat = function (item) {
        return (item.todayIncome || item.todayIncome == 0 || item.totalIncome || item.totalIncome == 0 || item.onlineTime);
    };
    /** 收益后端以分返回，展示为元保留两位 */
    View.prototype.formatInviteIncome = function (val) {
        var n = Number(val);
        return isNaN(n) ? '0.00' : (n / 100).toFixed(2);
    };
    /** 在线时长（秒）→「X小时YY分」 */
    View.prototype.formatInviteOnline = function (stamp) {
        var n = Number(stamp) || 0;
        var hours = Math.floor(n / 3600);
        var minutes = Math.floor((n % 3600) / 60);
        return hours + "\u5C0F\u65F6" + String(minutes).padStart(2, '0') + "\u5206";
    };
    /** 点击头像跳原生主页（对齐 InvitePanel → IncomeContent.completeMaterial，仅超推） */
    View.prototype.toPerson = function (item) {
        if (this.inviteInfo.userType == '3') {
            this.awlGlobalConfig.messageHandlers({
                route: commonConfig.Common.APPRoutes.home + item.uid,
                action: 0,
            });
        }
    };
    View.prototype.created = function () {
        var _this = this;
        this.package =
            this.awlGlobalState.urlInitParams.package && this.awlGlobalState.urlInitParams.package != 'undefined'
                ? this.awlGlobalState.urlInitParams.package
                : 'chuai';
        this.tabActive.tabIndex = this.awlGlobalState.Invite2Tabindex || 2;
        this.type = this.awlGlobalState.urlInitParams.type;
        this.navH = this.awlGlobalState.urlInitParams.navH;
        this.statusH = this.awlGlobalState.urlInitParams.statusH;
        this.inviteList = [];
        this.pageIndex = 1;
        window['doReloadData'] = function () {
            _this.doReloadData();
        };
        this.getH5Config();
        this.switchComponent();
        this.globalCommit('setting_pageJump', 1);
    };
    View.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInviteInfo()];
                    case 1:
                        _a.sent();
                        this.loadTabList();
                        return [2 /*return*/];
                }
            });
        });
    };
    View.prototype.getH5Config = function () {
        var _this = this;
        CommonService.getInstance()
            .getH5Config({})
            .then(function (data) {
            _this.h5Config = data;
        });
    };
    View.prototype.switchComponent = function () {
        var _this = this;
        if (this.awlGlobalConfig.platformNameBodyObj.isInviteQrcode) {
            this.componentId = QrcodeApp;
        }
        else if (this.awlGlobalState.defaultComponentList.includes(this.package)) {
            this.componentId = Qrcode;
        }
        else {
            import("../Qrcode" + this.package + ".vue")
                .then(function (module) {
                _this.componentId = module.default;
            })
                .catch(function () {
                _this.componentId = Qrcode;
            });
        }
    };
    View.prototype.tabHandle = function (item) {
        var _this = this;
        this.tabActive.tabIndex = item.index;
        this.globalCommit('setting_Invite2Tabindex', item.index);
        this.inviteList = [];
        this.pageIndex = 1;
        this.finished = false;
        this.isLoad = false;
        this.searchVal = '';
        this.selectActive = 0;
        this.loadTabList();
        this.$nextTick(function () {
            if (item.index == 1 && _this.inviteInfo.userType != '3' && _this.$refs.navSelect) {
                _this.$refs.navSelect.setActive('今日奖励');
            }
        });
    };
    View.prototype.loadTabList = function () {
        if (this.tabActive.tabIndex == 2) {
            this.getRecordList();
        }
        else if (this.tabActive.tabIndex == 1) {
            if (this.inviteInfo.userType == '3') {
                this.getIncomeList();
            }
            else {
                this.getInviteRewardRecord();
            }
        }
    };
    View.prototype.getInviteInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, PageService.getUserInvite({})];
                    case 1:
                        data = _a.sent();
                        this.inviteInfo = data;
                        this.bannerList = data.bannerList ? data.bannerList : [];
                        this.sharePic();
                        localStorage.removeItem('inviteTabIndex');
                        this.inviteInfo.minDate = new Date(moment(data.createdAt).format('YYYY-MM-DD'));
                        this.inviteInfo.maxDate = new Date(moment().format('YYYY-MM-DD'));
                        params = {};
                        if (data.userType == '3') {
                            params = {
                                startDate: data.startDate,
                                endDate: data.endDate,
                            };
                        }
                        this.getInviteStats(params);
                        return [2 /*return*/];
                }
            });
        });
    };
    View.prototype.getInviteStats = function (params) {
        var _this = this;
        PageService.getInviteStats(params).then(function (data) {
            _this.inviteInfo.inviteCount = data.inviteCount;
            _this.inviteInfo.inviteCountWeek = data.inviteCountWeek;
            _this.inviteInfo.incomeToday = data.incomeToday;
            _this.inviteInfo.incomeWeek = data.incomeWeek;
            _this.inviteInfo.income = data.income;
        });
    };
    View.prototype.getRecordList = function () {
        var _this = this;
        this.finished = false;
        this.isLoad = false;
        PageService.getInviteRecord({
            page: this.pageIndex,
            ttno: this.searchVal,
        }).then(function (data) {
            _this.isLoad = true;
            if (JSON.stringify(data.list) != '{}' && data.list.length != 0 && _this.pageIndex != 1) {
                _this.inviteList = __spreadArrays(_this.inviteList, data.list);
            }
            else if (JSON.stringify(data.list) != '{}' && data.list.length != 0 && _this.pageIndex == 1) {
                _this.inviteList = data.list;
            }
            else {
                _this.finished = true;
            }
            _this.loading = false;
        });
    };
    View.prototype.getIncomeList = function () {
        var _this = this;
        this.finished = false;
        this.isLoad = false;
        PageService.inviteRewardStatRecord({}).then(function (data) {
            _this.isLoad = true;
            _this.inviteList = data.list || [];
            _this.finished = true;
            _this.loading = false;
        });
    };
    View.prototype.getInviteRewardRecord = function () {
        var _this = this;
        this.finished = false;
        this.isLoad = false;
        PageService.getInviteRewardRecord({
            page: this.pageIndex,
            ttno: this.searchVal,
            type: this.selectActive,
        }).then(function (data) {
            _this.isLoad = true;
            if (JSON.stringify(data.list) != '{}' && data.list.length != 0 && _this.pageIndex != 1) {
                _this.inviteList = __spreadArrays(_this.inviteList, data.list);
            }
            else if (JSON.stringify(data.list) != '{}' && data.list.length != 0 && _this.pageIndex == 1) {
                _this.inviteList = data.list;
            }
            else {
                _this.finished = true;
            }
            _this.loading = false;
        });
    };
    View.prototype.onLoad = function () {
        this.loading = true;
        this.finished = false;
        this.pageIndex++;
        if (this.tabActive.tabIndex == 2) {
            this.getRecordList();
        }
        else if (this.inviteInfo.userType != '3') {
            this.getInviteRewardRecord();
        }
    };
    View.prototype.searchHandle = function () {
        this.inviteList = [];
        this.pageIndex = 1;
        this.finished = false;
        this.isLoad = false;
        this.loadTabList();
    };
    /** 华为鸿蒙 WebView 上 van-field clearable 偶发不同步 v-model，需手动清空 */
    View.prototype.onSearchClear = function () {
        var _this = this;
        console.log('onSearchClear');
        this.searchVal = '';
        this.$nextTick(function () {
            _this.searchVal = '';
            _this.searchHandle();
        });
    };
    View.prototype.selectHandle = function (e) {
        this.selectActive = e;
        this.inviteList = [];
        this.pageIndex = 1;
        this.finished = false;
        this.isLoad = false;
        this.searchVal = '';
        this.getInviteRewardRecord();
    };
    View.prototype.dateShowHandle = function () {
        this.calendarShow = true;
    };
    View.prototype.onCalendarConfirm = function (values) {
        var startDate = moment(values[0]).format('YYYY-MM-DD');
        var endDate = moment(values[1]).format('YYYY-MM-DD');
        this.inviteInfo.startDate = startDate;
        this.inviteInfo.endDate = endDate;
        this.calendarShow = false;
        this.getInviteStats({ startDate: startDate, endDate: endDate });
    };
    View.prototype.exportPage = function () {
        var param = {
            navH: this.awlGlobalState.urlInitParams.navH,
            statusH: this.awlGlobalState.urlInitParams.statusH,
            version: this.awlGlobalState.urlInitParams.version,
            token: this.awlGlobalState.urlInitParams.token,
        };
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        this.$router.push({
            path: '/nav/exportReport',
            query: param,
        });
    };
    View.prototype.toIncomeReport = function (item) {
        var param = {
            id: item.id,
            date: item.date,
            navH: this.awlGlobalState.urlInitParams.navH,
            statusH: this.awlGlobalState.urlInitParams.statusH,
            version: this.awlGlobalState.urlInitParams.version,
            token: this.awlGlobalState.urlInitParams.token,
        };
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        this.$router.push({
            path: '/nav/incomeReport',
            query: param,
        });
    };
    View.prototype.copyHandle = function (val) {
        AvalonGTGlobal.copyText(val);
    };
    View.prototype.sharePic = function () {
        var params = {
            imageUrl: this.inviteInfo.userAvatar,
            code: this.inviteInfo.inviteCode,
            title: this.inviteInfo.shareTitle,
            subtitle: this.inviteInfo.shareText,
            url: this.inviteInfo.shareLink + this.inviteInfo.inviteCode + '&package=' + this.package,
            nickName: this.inviteInfo.userNickname,
        };
        AvalonGTEvent.eventHub.emit(AvalonGTEvent.Global.GENERATE_PIC, params);
    };
    View.prototype.shareHandle = function (type, isShowToast) {
        var _this = this;
        if (type == 1) {
            Toast('正在生成海报');
        }
        else {
            if (isShowToast != 1) {
                AvalonGTGlobal.copyText(this.inviteInfo.shareLink + this.inviteInfo.inviteCode + '&package=' + this.package, '已复制链接');
            }
        }
        clearInterval(this.timer);
        this.timer = null;
        if (this.awlGlobalState.imageBase) {
            this.share(type);
        }
        else {
            this.timer = setInterval(function () {
                _this.shareHandle(type);
            }, 500);
        }
    };
    View.prototype.share = function (type) {
        Toast.clear();
        var params = {
            route: commonConfig.Common.APPRoutes.feedback,
            action: type,
            imageBase64: this.awlGlobalState.imageBase,
            imageUrl: this.inviteInfo.userAvatar,
            code: this.inviteInfo.inviteCode,
            title: this.inviteInfo.shareTitle,
            subtitle: this.inviteInfo.shareText,
            url: this.inviteInfo.shareLink + this.inviteInfo.inviteCode + '&package=' + this.package,
            copy: this.inviteInfo.shareText +
                "\n\n" +
                this.inviteInfo.shareTitle +
                "\n" +
                this.inviteInfo.shareLink +
                this.inviteInfo.inviteCode +
                '&package=' +
                this.package,
        };
        this.awlGlobalConfig.messageHandlers(params);
    };
    View.prototype.showHelp = function () {
        this.dialogScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = "-" + this.dialogScrollTop + "px";
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        this.showDialog = true;
    };
    View.prototype.closeHelpDialog = function () {
        var _this = this;
        this.showDialog = false;
        var scrollTop = this.dialogScrollTop;
        // 延后解锁，避免关闭点击的 touch 与恢复滚动冲突导致首滑失效
        this.$nextTick(function () {
            requestAnimationFrame(function () {
                _this.unlockPageScroll(scrollTop);
            });
        });
    };
    View.prototype.unlockPageScroll = function (scrollTop) {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollTop);
    };
    View.prototype.beforeUnmount = function () {
        if (this.showDialog) {
            this.unlockPageScroll(this.dialogScrollTop);
            this.showDialog = false;
        }
    };
    View.prototype.doReloadData = function () {
        return;
        this.pageIndex = 1;
        this.inviteList = [];
        this.loadTabList();
    };
    View.prototype.toSupplement = function () {
        var params = {
            isSupper: this.inviteInfo.userType == '3' || this.inviteInfo.userType == '1' ? true : false,
            navH: this.awlGlobalState.urlInitParams.navH,
            statusH: this.awlGlobalState.urlInitParams.statusH,
            version: this.awlGlobalState.urlInitParams.version,
            token: this.awlGlobalState.urlInitParams.token,
        };
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        this.$router.push({
            path: '/nav/supplement',
            query: params,
        });
    };
    View.prototype.toPage = function (item) {
        if (item.linkUrl) {
            this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
            var params = {
                action: 3,
                url: item.linkUrl,
                isImmersive: true,
            };
            this.awlGlobalConfig.messageHandlers(params);
        }
    };
    View.prototype.toBack = function () {
        this.globalCommit('setting_pageJump', 1);
        this.awlGlobalConfig.onBack();
    };
    View = __decorate([
        Options({
            components: {
                UnbindDialog: UnbindDialog,
                Qrcode: Qrcode,
                QrcodeApp: QrcodeApp,
                myDialog: myDialog,
                NavSelect: NavSelect,
            },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
